import { SupportedLanguages, useI18n as i18nHook } from '@migros/msrc-i18n';
const prefix = 'msrc-community';
const translations = {
  [SupportedLanguages.de]: () => require(`../translations/de.json`),
  [SupportedLanguages.en]: () => require(`../translations/en.json`),
  [SupportedLanguages.fr]: () => require(`../translations/fr.json`),
  [SupportedLanguages.it]: () => require(`../translations/it.json`)
};
export const useI18n = i18nHook(prefix, translations);